import { Group, Text } from '@mantine/core';
import { SOURCE_LABELS } from './brandIdentity';
import ConfidenceBadge from './ConfidenceBadge';

// Where an extracted value came from ("From your site: CSS variable"), with an amber
// "Please check" when the reader was not sure. Nothing for a value the client typed in.
const ProvenanceLabel = ({ source }) => {
  if (!source?.source) {
    return null;
  }
  const where = SOURCE_LABELS[source.source] || source.source;
  const text =
    source.source === 'derived' ? where.charAt(0).toUpperCase() + where.slice(1) : `From your site: ${where}`;

  return (
    <Group gap={6} wrap="nowrap" data-testid="provenance">
      <Text size="xs" c="dimmed">
        {text}
      </Text>
      <ConfidenceBadge level={source.confidence} />
    </Group>
  );
};

export default ProvenanceLabel;
